import getMonthAndDayWithOrdinalSuffix from './getMonthAndDayWithOrdinalSuffix';

const getAsSoonAsText = (
  asSoonAsText?: string | null,
  date?: Date | string | undefined
): string => {
  if (!asSoonAsText || !date) return '';

  return asSoonAsText.includes('/')
    ? getMonthAndDayWithOrdinalSuffix(date)
    : asSoonAsText;
};

export default getAsSoonAsText;
